import React, { FC } from "react";
import WizardField from "../../WizardField/WizardField";
import WizardHeader from "../WizardHeader/WizardHeader";

import "./FinancialConfiguration.scss";

import { ICreateClubWizardProps } from "../../../common/interfaces/clubs-wizard.interface";
import TradeApprovalConfiguration from "./TradeApprovalConfiguration/TradeApprovalConfiguration";

const FinancialConfiguration: FC<ICreateClubWizardProps> = (formConfig) => {
  return (
    <div className="financial-configuration">
      <WizardHeader description="Configure approval percentage needed for each type of proposal to pass and succeed. Different types of proposals might need a custom approval percentage. Note that if no custom approval percentage is defined, the general one will be used." />
      <div className="financial-config__voting">
        <div className="financial-config__voting-input">
          <WizardField
            type="number"
            placeholder="Type voting quorum here"
            label={formConfig.formFields.votingQuorum.label}
            name={formConfig.formFields.votingQuorum.name}
            tooltipTitle={`Minimum percentage (%) of 'accept' votes out of all possible votes`}
            leftPosition={-8}
          />
        </div>
        <div className="financial-config__voting-input">
          <WizardField
            placeholder="Type max vote time here"
            type="number"
            label={formConfig.formFields.maxVoteTime.label}
            name={formConfig.formFields.maxVoteTime.name}
            tooltipTitle="Maximum number of days before proposal is closed"
            leftPosition={-8}
            disabled
          />
        </div>
      </div>
      <p className="financial-config__title financial-config__title--withdrawal">
        Withdrawal configuration
      </p>
      <p className="financial-config__trade-description">
        Specify the number of “yes” votes required to perform a withdrawal of
        Treasury funds. Only the Founder can create a Withdrawal proposal.
      </p>
      <div className="financial-config__voting">
        <div className="financial-config__voting-input">
          <WizardField
            type="number"
            placeholder="Type voting quorum here"
            maxDecimalsLength={0}
            label={formConfig.formFields.withdrawalVotingQuorum.label}
            name={formConfig.formFields.withdrawalVotingQuorum.name}
            tooltipTitle={
              "Minimum percentage (%) of 'accept' votes out of all possible votes"
            }
            leftPosition={-8}
          />
        </div>
        <div className="financial-config__voting-input">
          <WizardField
            placeholder="Type max vote time here"
            type="number"
            maxDecimalsLength={0}
            label={formConfig.formFields.withdrawalMaxVoteTime.label}
            name={formConfig.formFields.withdrawalMaxVoteTime.name}
            tooltipTitle="Maximum number of days before proposal is closed"
            leftPosition={-8}
            disabled
          />
        </div>
      </div>
      <p className="financial-config__title financial-config__title--withdrawal">
        Transfer configuration
      </p>
      <div className="financial-config__voting">
        <div className="financial-config__voting-input">
          <WizardField
            type="number"
            placeholder="Type voting quorum here"
            maxDecimalsLength={0}
            label={formConfig.formFields.transferVotingQuorum.label}
            name={formConfig.formFields.transferVotingQuorum.name}
            tooltipTitle={
              "Minimum percentage (%) of 'accept' votes out of all possible votes"
            }
            leftPosition={-8}
          />
        </div>
        <div className="financial-config__voting-input">
          <WizardField
            placeholder="Type max vote time here"
            type="number"
            maxDecimalsLength={0}
            label={formConfig.formFields.transferMaxVoteTime.label}
            name={formConfig.formFields.transferMaxVoteTime.name}
            tooltipTitle="Maximum number of days before proposal is closed"
            leftPosition={-8}
            disabled
          />
        </div>
      </div>
      <p className="financial-config__title financial-config__title--withdrawal">
        Update club configuration
      </p>
      <div className="financial-config__voting">
        <div className="financial-config__voting-input">
          <WizardField
            type="number"
            placeholder="Type voting quorum here"
            maxDecimalsLength={0}
            label={formConfig.formFields.clubConfigQuorum.label}
            name={formConfig.formFields.clubConfigQuorum.name}
            tooltipTitle={
              "Minimum percentage (%) of 'accept' votes out of all possible votes"
            }
            leftPosition={-8}
          />
        </div>
        <div className="financial-config__voting-input">
          <WizardField
            placeholder="Type max vote time here"
            type="number"
            maxDecimalsLength={0}
            label={formConfig.formFields.clubConfigMaxVoteTime.label}
            name={formConfig.formFields.clubConfigMaxVoteTime.name}
            tooltipTitle="Maximum number of days before proposal is closed"
            leftPosition={-8}
            disabled
          />
        </div>
      </div>
      <TradeApprovalConfiguration formFields={formConfig.formFields} />
    </div>
  );
};

export default FinancialConfiguration;
